  <!-- 油卡申领记录 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" />

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 车辆档案新增弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel" ref="diaform" :rules="formRules" :Reset="isShowDialog" @changeCallback="rowCallback" />
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" />
    </exportCompoent>
  </div>
</template>
      <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1,exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "油卡申领记录", //导出时默认文件名
        apiName: "/admin/v3/tms/car/oil/OilCardd/getOilCardApplyRecordList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:oil_card:addOilCardApplyRecord",
        },

        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "input",
          label: "卡号",
          field: "oilCardNumber",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "操作",
          field: "operationType",
          placeholder: "请选择",
          selectOptions: [
            { label: "领用", val: "ling_yong:operation_type" },
            { label: "归还", val: "gui_huan:operation_type" },
          ],
        },
      ],

      queryData: {
        oilCardNumber: null,
        operationType: null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "卡号",
          field: "oilCardNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "操作",
          field: "operationTypeShow",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "经办人",
          field: "handleUserName",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "经办日期",
          field: "handleTime",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "备注",
          field: "remarks",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        // {
        //   name: "创建时间",
        //   field: "packageStatusShow",
        //   width: "200",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
      ],
      sortName: "油卡申领记录", //  排序名
      pageGroupName: "GasApply", //  页面标识
      //   车辆弹窗
      diaWidth: "60%",
      dialogTitle: "油卡领用记录",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "操作",
              itemType: "select",
              field: "operationType",
              setLabel: "showName",
              setValue: "statusVal",
              placeholder: "请选择",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "卡号",
              itemType: "selectloadmore",
              field: "oilCardNumber",
              setLabel: "oilCardNumber",
              setValue: "oilCardNumber",
              loadmoreMethod: "loadoilCard",
              remotemethod: "remoteoilCard",
              loading: false,
              placeholder: "输入卡号进行匹配",
              options: [],
            },
            {
              span: 8,
              title: "经办人",
              itemType: "input",
              field: "handleUserName",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "经办日期",
              itemType: "datetime",
              field: "handleTime",
              placeholder: "请选择",
            },
          ],
        },

        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "remarks",
              placeholder: "请输入",
            },
          ],
        },
      ],
      formRules: {
        oilCardNumber: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        operationType: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      baseModel: {},
      defaultBaseModel: {
        oilCardId: null,
        oilCardNumber: null,
        operationType: null,
        handleTime: null,
        handleUserName: null,
        remarks: null,
      },
      OilCardPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
    this.GetOilCardDownList();
    this.GetOperationType();
  },
  methods: {
    // 获取油卡申领记录列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.OilCardApplyRecordList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result?.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---油卡申领记录列表`);
        }
      });
    },
    // 获取操作类型下拉列表
    GetOperationType() {
      this.$TOOLS
        .getStatusValList("car_oil_card_apply_record_v3.operation_type")
        .then((res) => {
          this.diaFormConfig[0].formItem[0].options = res;
        });
    },
    // 获取油卡列表
    GetOilCardDownList(e, checkedData) {
      let query = {
        pageStart: this.OilCardPage.pageStart,
        pageTotal: this.OilCardPage.pageTotal,
        oilCardNumber: e,
        oilCardId: checkedData,
      };
      this.$API
        .OilCardDownList(query)
        .then((res) => {
          this.diaFormConfig[1].formItem[0].loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.diaFormConfig[1].formItem[0].options;
            if (e) {
              this.diaFormConfig[1].formItem[0].options = result;
            } else {
              this.diaFormConfig[1].formItem[0].options = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.oilCardId === item.oilCardId)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.OilCardPage.pageCount = res.data.result?.pageCount || 0;
            }
          } else {
            this.$message.error(`${res.data.message}---油卡下拉列表`);
          }
        })
        .catch((catchres) => {
          this.diaFormConfig[1].formItem[0].loading = false;
        });
    },
    // 油卡列表远程搜索
    remoteoilCard(e) {
      this.OilCardPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[1].formItem[0].loading = true;
        this.GetOilCardDownList(e);
      } else {
        this.GetOilCardDownList();
      }
    },
    // 油卡列表下拉加载更多
    loadoilCard() {
      let count = this.OilCardPage.pageCount / this.OilCardPage.pageTotal;
      if (count > this.OilCardPage.pageStart) {
        this.diaFormConfig[1].formItem[0].loading = true;
        this.OilCardPage.pageStart += 1;
        this.GetOilCardDownList();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 新增
    addClick() {
      this.isShowDialog = true;
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          // 获取油卡id
          let oilCardIdArr = this.diaFormConfig[1].formItem[0].options;
          let index_1 = oilCardIdArr.findIndex(
            (elem) => elem.oilCardNumber == this.baseModel.oilCardNumber
          );
          param.oilCardId = oilCardIdArr[index_1].oilCardId;

          // 新建油卡申领记录
          this.$API.addOilCardApplyRecord(param).then((res) => {
            if (res.data.status === "success") {
              this.$message.success(res.data.message);
              this.isShowDialog = false;
              this.GetData();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.baseModel = {};
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
  },
};
</script>
      <style scoped lang="less">
</style>
      